import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Styles from "../BuySell/BuySell.module.css";
import { useLocation } from "react-router-dom";
import {
  fetchActiveLedger,
  fetchArchiveList,
  fetchArchiveWithdrawanList,
  fetchBankingArchive,
  fetchMatchmakingResults,
} from "../../../Redux/Slices/bankingSlice";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../../commons/Accordion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ActiveListingConnection from "../../Modals/Banking/BankingReceivedTabs/ActiveListingConnection/ActiveListingConnection";
import { ReactComponent as SquareIcon } from "../../../assets/images/squareIcon.svg";
import ViewInjectionModal from "../../Modals/Banking/ViewInjectionModal/ViewInjectionModal";
import ViewDrawalModal from "../../Modals/Banking/ViewDrawalModal/ViewDrawalModal";
import { openBilateralChat } from "../../Modals/Banking/CreateEdit/helpers";

const LoaderNoData = ({ loading, dataLength }) => {
  if (loading) {
    return (
      <div className={Styles.loaderContainer}>
        <div className={Styles.loader} role="status" aria-label="loading" />
      </div>
    );
  }
  if (!loading && dataLength === 0) {
    return <div className={Styles.noDataContainer}>No records found</div>;
  }
  return null;
};

const SummaryHeader = () => (
  <div className={Styles.accordionSummaryContainer}>
    <table
      className={Styles.summaryTable}
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <colgroup>
        <col style={{ width: "5%" }} />
        <col style={{ width: "15%" }} />
        <col style={{ width: "19%" }} />
        <col style={{ width: "22%" }} />
        <col style={{ width: "10%" }} />
        <col style={{ width: "10%" }} />
        {/* <col style={{ width: "12%" }} /> */}
      </colgroup>
      <thead className={Styles.summaryHeader}>
        <tr>
          <th className={Styles.summaryHeaderCell}>S.No</th>
          <th className={Styles.summaryHeaderCell}>Listing Id</th>
          <th className={Styles.summaryHeaderCell}>Injection Range</th>
          <th className={Styles.summaryHeaderCell}>Drawal Range</th>
          <th className={Styles.summaryHeaderCell}>BF(%)</th>
          <th className={Styles.summaryHeaderCell}>SR(₹/kWh)</th>
          {/* <th className={Styles.summaryHeaderCell}>Status</th> */}
        </tr>
      </thead>
    </table>
  </div>
);

const SummaryHeaderWithdrawn = () => (
  <div className={Styles.accordionSummaryContainer}>
    <table
      className={`scroll_bar_y ${Styles.summaryTable}`}
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <colgroup>
        <col style={{ width: "5%" }} />
        <col style={{ width: "15%" }} />
        <col style={{ width: "19%" }} />
        <col style={{ width: "22%" }} />
        <col style={{ width: "10%" }} />
        <col style={{ width: "10%" }} />
        {/* <col style={{ width: "12%" }} /> */}
      </colgroup>
      <thead className={Styles.summaryHeader}>
        <tr>
          <th className={Styles.summaryHeaderCell}>S.No</th>
          <th className={Styles.summaryHeaderCell}>Listing Id</th>
          <th className={Styles.summaryHeaderCell}>Injection Range</th>
          <th className={Styles.summaryHeaderCell}>Drawal Range</th>
          <th className={Styles.summaryHeaderCell}>BF(%)</th>
          <th className={Styles.summaryHeaderCell}>SR(₹/kWh)</th>
          {/* <th className={Styles.summaryHeaderCell}>Expired On</th> */}
        </tr>
      </thead>
    </table>
  </div>
);

const SummaryHeaderExpired = () => (
  <div className={Styles.accordionSummaryContainer}>
    <table
      className={`scroll_bar_y ${Styles.summaryTable}`}
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <colgroup>
        <col style={{ width: "5%" }} />
        <col style={{ width: "15%" }} />
        <col style={{ width: "19%" }} />
        <col style={{ width: "22%" }} />
        <col style={{ width: "10%" }} />
        <col style={{ width: "10%" }} />
        <col style={{ width: "12%" }} />
      </colgroup>
      <thead className={Styles.summaryHeader}>
        <tr>
          <th className={Styles.summaryHeaderCell}>S.No</th>
          <th className={Styles.summaryHeaderCell}>Listing Id</th>
          <th className={Styles.summaryHeaderCell}>Injection Range</th>
          <th className={Styles.summaryHeaderCell}>Drawal Range</th>
          <th className={Styles.summaryHeaderCell}>BF(%)</th>
          <th className={Styles.summaryHeaderCell}>SR(₹/kWh)</th>
          <th className={Styles.summaryHeaderCell}>Expired On</th>
        </tr>
      </thead>
    </table>
  </div>
);

const SummaryRow = ({ ele, index, expanded, onToggle }) => {
  const dispatch = useDispatch();
  const [viewInjectionModalOpen, setViewInjectionModalOpen] = useState(false);
  const [selectedInjectionData, setSelectedInjectionData] = useState([]);
  const [viewDrawalModalOpen, setViewDrawalModalOpen] = useState(false);
  const [selectedDrawalData, setSelectedDrawalData] = useState([]);

  const { archiveListConnection = [], loading: matchmakingLoading = false } =
    useSelector((state) => state.bankingSlice || {});

  if (!ele) return null;

  const inject = ele?.bankingSlotInjects?.[0];
  const drawal = ele?.bankingSlotDrawls?.[0];

  const ledgerPage = Array.isArray(archiveListConnection)
    ? archiveListConnection
    : [];

  const connectionData =
    ledgerPage.length > 0
      ? ledgerPage
      : [
          {
            selfListing: ele,
            counterPartyListings: [],
          },
        ];

  const handleAccordionChange = () => {
    onToggle(index);

    if (expanded !== index) {
      dispatch(
        fetchArchiveList({
          currentPage: 0,
          size: 20,
          listingId: ele?.id,
          status: "DELIVERED",
        })
      );
    }
  };

  const handleViewInjection = (slotData) => {
    if (!slotData || slotData.length === 0) return;
    setSelectedInjectionData(slotData);
    setViewInjectionModalOpen(true);
  };

  const handleViewDrawal = (slotData) => {
    if (!slotData || slotData.length === 0) return;
    setSelectedDrawalData(slotData);
    setViewDrawalModalOpen(true);
  };

  return (
    <div className={expanded === index ? "" : Styles.detailsMainDrop_inactive}>
      <Accordion
        style={{
          backgroundColor: "#f3f5f8",
          marginTop: index === 0 ? "0px" : "3px",
          border:
            expanded === index ? "1px solid var(--primary-color-text)" : "none",
          borderRadius: "10px",
        }}
        expanded={expanded === index}
        onChange={handleAccordionChange}
      >
        <AccordionSummary
          style={{
            backgroundColor: "white",
            borderRadius: "8px",
          }}
        >
          <div className={Styles.accordionSummaryContainer}>
            <table
              className={Styles.summaryTable}
              style={{ tableLayout: "fixed", width: "100%" }}
            >
              <colgroup>
                <col style={{ width: "5%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "19%" }} />
                <col style={{ width: "22%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
                {/* <col style={{ width: "12%" }} /> */}
              </colgroup>
              <tbody>
                <tr>
                  <td className={Styles.summaryCell}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 6,
                      }}
                    >
                      <ExpandMoreIcon
                        style={{ fontSize: "18px" }}
                        className={`${Styles.expandIconLeft} ${
                          expanded === index ? Styles.rotateIcon : ""
                        }`}
                      />
                    </div>
                  </td>
                  <td className={Styles.summaryCell}>{ele?.name || "-"}</td>
                  <td className={Styles.summaryCell}>
                    {inject?.dateStartAt || "—"} to {inject?.dateEndAt || "—"}
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        handleViewInjection(ele?.bankingSlotInjects);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <SquareIcon
                        style={{
                          width: "10px",
                          height: "10px",
                          paddingLeft: "4px",
                        }}
                      />
                    </span>
                  </td>
                  <td className={Styles.summaryCell}>
                    {drawal?.dateStartAt || "—"} to {drawal?.dateEndAt || "—"}
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        handleViewDrawal(ele?.bankingSlotDrawls);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <SquareIcon
                        style={{
                          width: "10px",
                          height: "10px",
                          paddingLeft: "4px",
                        }}
                      />
                    </span>
                  </td>
                  <td className={Styles.summaryCell}>
                    {ele?.bankingFactor
                      ? Number(ele.bankingFactor).toFixed(2)
                      : "—"}
                  </td>
                  <td className={Styles.summaryCell}>
                    {ele?.settlementRate || "—"}
                  </td>
                  {/* <td className={Styles.summaryCell}>
                    <span className={Styles.selfStatus}>
                      {ele?.status || "—"}
                    </span>
                  </td> */}
                </tr>
              </tbody>
            </table>
          </div>
        </AccordionSummary>

        <AccordionDetails style={{ backgroundColor: "white" }}>
          {expanded === index && (
            <ActiveListingConnection
              data={connectionData}
              isLoading={matchmakingLoading}
              onRefresh={() => {}}
              onOngoingStatusDetected={() => {}}
            />
          )}
        </AccordionDetails>
      </Accordion>

      {viewInjectionModalOpen && (
        <ViewInjectionModal
          open={viewInjectionModalOpen}
          handleClose={() => setViewInjectionModalOpen(false)}
          data={selectedInjectionData}
        />
      )}

      {viewDrawalModalOpen && (
        <ViewDrawalModal
          open={viewDrawalModalOpen}
          handleClose={() => setViewDrawalModalOpen(false)}
          data={selectedDrawalData}
        />
      )}
    </div>
  );
};

const SummaryRowWithdrawn = ({ ele, index, expanded, onToggle }) => {
  const dispatch = useDispatch();
  const [viewInjectionModalOpen, setViewInjectionModalOpen] = useState(false);
  const [selectedInjectionData, setSelectedInjectionData] = useState([]);
  const [viewDrawalModalOpen, setViewDrawalModalOpen] = useState(false);
  const [selectedDrawalData, setSelectedDrawalData] = useState([]);

  const { archiveWithdrawnListConnection, loading } = useSelector(
    (state) => state.bankingSlice || {}
  );
  const withdrawanData = Array.isArray(archiveWithdrawnListConnection)
    ? archiveWithdrawnListConnection
        .map((item) => item?.againstBankingListing)
        .filter(Boolean)
    : [];

  if (!ele) return null;

  const inject = ele?.bankingSlotInjects?.[0];
  const drawal = ele?.bankingSlotDrawls?.[0];

  const handleChatOpen = (fromUser, toUser) => {
    openBilateralChat(dispatch, {
      header: toUser,
      fromUser,
      toUser,
    });
  };

  const handleAccordionChange = () => {
    onToggle(index);

    if (expanded !== index) {
      dispatch(
        fetchArchiveWithdrawanList({
          currentPage: 0,
          size: 20,
          listingId: ele?.id,
        })
      );
    }
  };

  const handleViewInjection = (slotData) => {
    if (!slotData || slotData.length === 0) return;
    setSelectedInjectionData(slotData);
    setViewInjectionModalOpen(true);
  };

  const handleViewDrawal = (slotData) => {
    if (!slotData || slotData.length === 0) return;
    setSelectedDrawalData(slotData);
    setViewDrawalModalOpen(true);
  };

  return (
    <>
      <div
        className={expanded === index ? "" : Styles.detailsMainDrop_inactive}
      >
        <Accordion
          expanded={expanded === index}
          onChange={handleAccordionChange}
          style={{
            backgroundColor: "#f3f5f8",
            marginTop: index === 0 ? "0px" : "3px",
            border:
              expanded === index
                ? "1px solid var(--primary-color-text)"
                : "none",
            borderRadius: "10px",
          }}
        >
          <AccordionSummary
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
            }}
          >
            <div className={Styles.accordionSummaryContainer}>
              <table
                className={Styles.summaryTable}
                style={{ tableLayout: "fixed", width: "100%" }}
              >
                <colgroup>
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "15%" }} />
                  <col style={{ width: "19%" }} />
                  <col style={{ width: "22%" }} />
                  <col style={{ width: "10%" }} />
                  <col style={{ width: "10%" }} />
                  {/* <col style={{ width: "12%" }} /> */}
                </colgroup>
                <tbody>
                  <tr>
                    <td className={Styles.summaryCell}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 6,
                        }}
                      >
                        <ExpandMoreIcon
                          style={{ fontSize: "18px" }}
                          className={`${Styles.expandIconLeft} ${
                            expanded === index ? Styles.rotateIcon : ""
                          }`}
                        />
                        {index + 1}
                      </div>
                    </td>

                    <td className={Styles.summaryCell}>{ele?.name || "-"}</td>

                    <td className={Styles.summaryCell}>
                      {inject?.dateStartAt || "—"} to {inject?.dateEndAt || "—"}
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          handleViewInjection(ele?.bankingSlotInjects);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <SquareIcon
                          style={{
                            width: "10px",
                            height: "10px",
                            paddingLeft: 4,
                          }}
                        />
                      </span>
                    </td>

                    <td className={Styles.summaryCell}>
                      {drawal?.dateStartAt || "—"} to {drawal?.dateEndAt || "—"}
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          handleViewDrawal(ele?.bankingSlotDrawls);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <SquareIcon
                          style={{
                            width: "10px",
                            height: "10px",
                            paddingLeft: 4,
                          }}
                        />
                      </span>
                    </td>

                    <td className={Styles.summaryCell}>
                      {Number(ele?.bankingFactor).toFixed(2) ?? "—"}
                    </td>

                    <td className={Styles.summaryCell}>
                      {ele?.settlementRate ?? "—"}
                    </td>

                    {/* <td className={Styles.summaryCell}>
                    <span className={Styles.selfStatus}>
                      {ele?.status || "—"}
                    </span>
                  </td> */}
                  </tr>
                </tbody>
              </table>
            </div>
          </AccordionSummary>

          <AccordionDetails
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
            }}
          >
            <div
              className={Styles.accordionDetailsContainerUploadDocs}
              style={{
                margin: "0px 10px 10px 10px",
                border: expanded === index ? "1px solid #34656D" : "none",
              }}
            >
              {/* Loader */}
              {expanded === index && loading && (
                <div className={Styles.loaderContainer}>
                  <div
                    className={Styles.loader}
                    role="status"
                    aria-label="loading matches"
                  />
                </div>
              )}

              {expanded === index && !loading && (
                <div
                  style={{ margin: "7px" }}
                  className={`display_flex_row ${Styles.activeListHead}`}
                >
                  <table
                    className={Styles.ledgerTableHeading}
                    style={{
                      width: "100%",
                      tableLayout: "fixed",
                      fontSize: "12px",
                      fontWeight: 600,
                      color: "var(--fourth-color-text)",
                    }}
                  >
                    <colgroup>
                      <col style={{ width: "4%" }} />
                      <col style={{ width: "18%" }} />
                      <col style={{ width: "18%" }} />
                      <col style={{ width: "18%" }} />
                      <col style={{ width: "10%" }} />
                      <col style={{ width: "12%" }} />
                      {/* <col
                        style={{
                          width: "18%",
                        }}
                      /> */}
                    </colgroup>

                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Name</th>
                        <th>Injection Range</th>
                        <th>Drawal Range</th>
                        <th>BF(%)</th>
                        <th>SR(₹/kWh)</th>
                        {/* <th
                          style={{ textAlign: "right", paddingRight: "3.5%" }}
                        >
                          Action
                        </th> */}
                      </tr>
                    </thead>
                  </table>
                </div>
              )}

              {/* Content */}
              {expanded === index &&
                !loading &&
                (Array.isArray(withdrawanData) && withdrawanData.length > 0 ? (
                  withdrawanData.map((match, idx) => {
                    const inject = match?.bankingSlotInjects?.[0];

                    const drawal = match?.bankingSlotDrawls?.[0];

                    return (
                      <div key={match.id} style={{ margin: "7px" }}>
                        <table
                          className={Styles.ledgerTableHeading}
                          style={{
                            width: "100%",
                            tableLayout: "fixed",
                            fontSize: "12px",
                            color: "var(--fourth-color-text)",
                          }}
                        >
                          <colgroup>
                            <col style={{ width: "4%" }} />
                            <col style={{ width: "18%" }} />
                            <col style={{ width: "18%" }} />
                            <col style={{ width: "18%" }} />
                            <col style={{ width: "10%" }} />
                            <col style={{ width: "14%" }} />
                            {/* <col style={{ width: "20%" }} /> */}
                          </colgroup>

                          <tbody>
                            <tr>
                              <td>{idx + 1}</td>

                              <td>{match?.name || "-"}</td>

                              <td>
                                {inject?.dateStartAt || "—"} to{" "}
                                {inject?.dateEndAt || "—"}
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewInjection(
                                      match?.bankingSlotInjects
                                    );
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  <SquareIcon
                                    style={{
                                      width: "10px",
                                      height: "10px",
                                      paddingLeft: "4px",
                                    }}
                                  />
                                </span>
                              </td>

                              <td>
                                {drawal?.dateStartAt || "—"} to{" "}
                                {drawal?.dateEndAt || "—"}
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewDrawal(match?.bankingSlotDrawls);
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  <SquareIcon
                                    style={{
                                      width: "10px",
                                      height: "10px",
                                      paddingLeft: "4px",
                                    }}
                                  />
                                </span>
                              </td>

                              <td>
                                {Number(match?.bankingFactor)?.toFixed(2) ??
                                  "—"}
                              </td>

                              <td>{match?.settlementRate ?? "—"}</td>

                              {/* <td>
                                <div className={Styles.chatButtonContainer}>
                                  <button
                                    type="button"
                                    className={Styles.chatButton}
                                    onClick={() =>
                                      handleChatOpen(
                                        ele?.name,
                                        match?.companyName
                                      )
                                    }
                                  >
                                    View Chat
                                  </button>
                                </div>
                              </td> */}
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    );
                  })
                ) : (
                  <div className={Styles.noDataContainer}>
                    No matching records
                  </div>
                ))}
              {/* {expanded === index && !loading && (
                <div className={Styles.noDataContainer}>
                  No matching records
                </div>
              )} */}
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
      {viewInjectionModalOpen && (
        <ViewInjectionModal
          open={viewInjectionModalOpen}
          handleClose={() => setViewInjectionModalOpen(false)}
          data={selectedInjectionData}
        />
      )}

      {viewDrawalModalOpen && (
        <ViewDrawalModal
          open={viewDrawalModalOpen}
          handleClose={() => setViewDrawalModalOpen(false)}
          data={selectedDrawalData}
        />
      )}
    </>
  );
};

// const SummaryRowExpired = ({ ele, index, expanded, onToggle }) => {
//   const dispatch = useDispatch();

//   const [viewInjectionModalOpen, setViewInjectionModalOpen] = useState(false);
//   const [selectedInjectionData, setSelectedInjectionData] = useState([]);
//   const [viewDrawalModalOpen, setViewDrawalModalOpen] = useState(false);
//   const [selectedDrawalData, setSelectedDrawalData] = useState([]);

//   const {
//     matchmakingData,
//     loading: matchmakingLoading,
//     activeLedgerData = [],
//   } = useSelector((state) => state.bankingSlice || {});

//   if (!ele) return null;

//   const isPast = ele?.status === "PAST"; // ← key line
//   const inject = ele?.bankingSlotInjects?.[0];
//   const drawal = ele?.bankingSlotDrawls?.[0];

//   const ledgerPage = Array.isArray(activeLedgerData) ? activeLedgerData : [];
//   const connectionData =
//     ledgerPage.length > 0
//       ? ledgerPage
//       : [
//           {
//             selfListing: ele,
//             counterPartyListings: [],
//           },
//         ];

//   const handleAccordionChange = () => {
//     onToggle(index);

//     // Do NOT call APIs for PAST
//     if (expanded !== index && !isPast) {
//       dispatch(
//         fetchMatchmakingResults({
//           id: ele?.id,
//           statusFilter: null,
//         })
//       );

//       dispatch(
//         fetchActiveLedger({
//           currentPage: 0,
//           size: 20,
//           bankingListingId: ele?.id,
//         })
//       );
//     }
//   };

//   const handleViewInjection = (slotData) => {
//     if (!slotData || slotData.length === 0) return;
//     setSelectedInjectionData(slotData);
//     setViewInjectionModalOpen(true);
//   };

//   const handleViewDrawal = (slotData) => {
//     if (!slotData || slotData.length === 0) return;
//     setSelectedDrawalData(slotData);
//     setViewDrawalModalOpen(true);
//   };

//   return (
//     <div className={expanded === index ? "" : Styles.detailsMainDrop_inactive}>
//       <Accordion
//         expanded={expanded === index}
//         onChange={handleAccordionChange}
//         style={{
//           backgroundColor: "#f3f5f8",
//           marginTop: index === 0 ? "0px" : "3px",
//           border:
//             expanded === index ? "1px solid var(--primary-color-text)" : "none",
//           borderRadius: "10px",
//         }}
//       >
//         <AccordionSummary
//           style={{
//             backgroundColor: "white",
//             borderRadius: "8px",
//           }}
//         >
//           <div className={Styles.accordionSummaryContainer}>
//             <table
//               className={Styles.summaryTable}
//               style={{ tableLayout: "fixed", width: "100%" }}
//             >
//               <colgroup>
//                 <col style={{ width: "5%" }} />
//                 <col style={{ width: "15%" }} />
//                 <col style={{ width: "19%" }} />
//                 <col style={{ width: "22%" }} />
//                 <col style={{ width: "10%" }} />
//                 <col style={{ width: "10%" }} />
//               </colgroup>
//               <tbody>
//                 <tr>
//                   <td className={Styles.summaryCell}>
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         gap: 6,
//                       }}
//                     >
//                       <ExpandMoreIcon
//                         style={{ fontSize: "18px" }}
//                         className={`${Styles.expandIconLeft} ${
//                           expanded === index ? Styles.rotateIcon : ""
//                         }`}
//                       />
//                       {index + 1}
//                     </div>
//                   </td>
//                   <td className={Styles.summaryCell}>{ele?.name || "-"}</td>
//                   <td className={Styles.summaryCell}>
//                     {inject?.dateStartAt || "—"} to {inject?.dateEndAt || "—"}
//                     <span
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleViewInjection(ele?.bankingSlotInjects);
//                       }}
//                       style={{ cursor: "pointer" }}
//                     >
//                       <SquareIcon
//                         style={{
//                           width: "10px",
//                           height: "10px",
//                           paddingLeft: 4,
//                         }}
//                       />
//                     </span>
//                   </td>
//                   <td className={Styles.summaryCell}>
//                     {drawal?.dateStartAt || "—"} to {drawal?.dateEndAt || "—"}
//                     <span
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleViewDrawal(ele?.bankingSlotDrawls);
//                       }}
//                       style={{ cursor: "pointer" }}
//                     >
//                       <SquareIcon
//                         style={{
//                           width: "10px",
//                           height: "10px",
//                           paddingLeft: 4,
//                         }}
//                       />
//                     </span>
//                   </td>
//                   <td className={Styles.summaryCell}>
//                     {ele?.bankingFactor ?? "—"}
//                   </td>
//                   <td className={Styles.summaryCell}>
//                     {ele?.settlementRate ?? "—"}
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </AccordionSummary>

//         <AccordionDetails
//           style={{
//             backgroundColor: "white",
//             borderRadius: "8px",
//             // padding: "20px",
//           }}
//         >
//           {expanded === index &&
//             (isPast ? (
//               <div
//                 style={{
//                   padding: "10px",
//                   textAlign: "center",
//                   color: "var(--secondary-color-text)",
//                   // border: "var(--border-brand-2)",
//                   width: "95%",
//                   margin: "auto",
//                   borderRadius: "8px",
//                 }}
//               >
//                 No matching records
//               </div>
//             ) : (
//               <>
//                 {connectionData && connectionData.length > 0 ? (
//                   <ActiveListingConnection
//                     data={connectionData}
//                     isLoading={matchmakingLoading}
//                     onRefresh={() => {}}
//                     onOngoingStatusDetected={() => {}}
//                   />
//                 ) : (
//                   <div
//                     style={{
//                       padding: "10px",
//                       textAlign: "center",
//                       color: "var(--secondary-color-text)",
//                       fontStyle: "italic",
//                     }}
//                   >
//                     No matching records
//                   </div>
//                 )}

//                 {/* {Array.isArray(matchmakingData?.matches) &&
//                 matchmakingData.matches.length > 0 ? (
//                   <div
//                     className={Styles.accordionDetailsContainerUploadDocs}
//                     style={{
//                       margin: "10px 10px 0 10px",
//                       border: expanded === index ? "1px solid #34656D" : "none",
//                     }}
//                   >
//                   </div>
//                 ) : null} */}
//               </>
//             ))}
//         </AccordionDetails>
//       </Accordion>

//       {viewInjectionModalOpen && (
//         <ViewInjectionModal
//           open={viewInjectionModalOpen}
//           handleClose={() => setViewInjectionModalOpen(false)}
//           data={selectedInjectionData}
//         />
//       )}

//       {viewDrawalModalOpen && (
//         <ViewDrawalModal
//           open={viewDrawalModalOpen}
//           handleClose={() => setViewDrawalModalOpen(false)}
//           data={selectedDrawalData}
//         />
//       )}
//     </div>
//   );
// };

const SummaryRowExpired = ({ ele, index, expanded, onToggle }) => {
  const dispatch = useDispatch();
  const [viewInjectionModalOpen, setViewInjectionModalOpen] = useState(false);
  const [selectedInjectionData, setSelectedInjectionData] = useState([]);
  const [viewDrawalModalOpen, setViewDrawalModalOpen] = useState(false);
  const [selectedDrawalData, setSelectedDrawalData] = useState([]);

  const { archiveListConnection = [], loading: matchmakingLoading = false } =
    useSelector((state) => state.bankingSlice || {});

  if (!ele) return null;

  const inject = ele?.bankingSlotInjects?.[0];
  const drawal = ele?.bankingSlotDrawls?.[0];

  const ledgerPage = Array.isArray(archiveListConnection)
    ? archiveListConnection
    : [];

  const connectionData =
    ledgerPage.length > 0
      ? ledgerPage
      : [
          {
            selfListing: ele,
            counterPartyListings: [],
          },
        ];

  const handleAccordionChange = () => {
    onToggle(index);

    if (expanded !== index) {
      dispatch(
        fetchArchiveList({
          currentPage: 0,
          size: 20,
          listingId: ele?.id,
        })
      );
    }
  };

  const handleViewInjection = (slotData) => {
    if (!slotData || slotData.length === 0) return;
    setSelectedInjectionData(slotData);
    setViewInjectionModalOpen(true);
  };

  const handleViewDrawal = (slotData) => {
    if (!slotData || slotData.length === 0) return;
    setSelectedDrawalData(slotData);
    setViewDrawalModalOpen(true);
  };

  const isPast = connectionData?.[0]?.counterPartyListings?.length === 0;
  return (
    <div className={expanded === index ? "" : Styles.detailsMainDrop_inactive}>
      <Accordion
        style={{
          backgroundColor: "#f3f5f8",
          marginTop: index === 0 ? "0px" : "3px",
          border:
            expanded === index ? "1px solid var(--primary-color-text)" : "none",
          borderRadius: "10px",
        }}
        expanded={expanded === index}
        onChange={handleAccordionChange}
      >
        <AccordionSummary
          style={{
            backgroundColor: "white",
            borderRadius: "8px",
          }}
        >
          <div className={Styles.accordionSummaryContainer}>
            <table
              className={Styles.summaryTable}
              style={{ tableLayout: "fixed", width: "100%" }}
            >
              <colgroup>
                <col style={{ width: "5%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "19%" }} />
                <col style={{ width: "22%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "12%" }} />
              </colgroup>
              <tbody>
                <tr>
                  <td className={Styles.summaryCell}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 6,
                      }}
                    >
                      <ExpandMoreIcon
                        style={{ fontSize: "18px" }}
                        className={`${Styles.expandIconLeft} ${
                          expanded === index ? Styles.rotateIcon : ""
                        }`}
                      />
                      {/* {index + 1} */}
                    </div>
                  </td>
                  <td className={Styles.summaryCell}>{ele?.name || "-"}</td>
                  <td className={Styles.summaryCell}>
                    {inject?.dateStartAt || "—"} to {inject?.dateEndAt || "—"}
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        handleViewInjection(ele?.bankingSlotInjects);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <SquareIcon
                        style={{
                          width: "10px",
                          height: "10px",
                          paddingLeft: "4px",
                        }}
                      />
                    </span>
                  </td>
                  <td className={Styles.summaryCell}>
                    {drawal?.dateStartAt || "—"} to {drawal?.dateEndAt || "—"}
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        handleViewDrawal(ele?.bankingSlotDrawls);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <SquareIcon
                        style={{
                          width: "10px",
                          height: "10px",
                          paddingLeft: "4px",
                        }}
                      />
                    </span>
                  </td>
                  <td className={Styles.summaryCell}>
                    {ele?.bankingFactor
                      ? Number(ele.bankingFactor).toFixed(2)
                      : "—"}
                  </td>
                  <td className={Styles.summaryCell}>
                    {ele?.settlementRate || "—"}
                  </td>
                  {/* <td className={Styles.summaryCell}>
                    <span className={Styles.selfStatus}>
                      {ele?.status || "—"}
                    </span>
                  </td> */}
                  <td className={Styles.summaryCell}>{ele?.expiryAt || "—"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </AccordionSummary>

        <AccordionDetails style={{ backgroundColor: "white" }}>
          {expanded === index && (
            <>
              {!isPast ? (
                <ActiveListingConnection
                  data={connectionData}
                  isLoading={matchmakingLoading}
                  onRefresh={() => {}}
                  onOngoingStatusDetected={() => {}}
                />
              ) : (
                <div
                  style={{
                    padding: "10px",
                    textAlign: "center",
                    color: "var(--secondary-color-text)",
                  }}
                >
                  No matching records
                </div>
              )}
              {/* <div
                style={{
                  padding: "10px",
                  textAlign: "center",
                  color: "var(--secondary-color-text)",
                }}
              >
                No matching records
              </div> */}
            </>
          )}
        </AccordionDetails>
      </Accordion>

      {viewInjectionModalOpen && (
        <ViewInjectionModal
          open={viewInjectionModalOpen}
          handleClose={() => setViewInjectionModalOpen(false)}
          data={selectedInjectionData}
        />
      )}

      {viewDrawalModalOpen && (
        <ViewDrawalModal
          open={viewDrawalModalOpen}
          handleClose={() => setViewDrawalModalOpen(false)}
          data={selectedDrawalData}
        />
      )}
    </div>
  );
};

const BankingArchive = ({ type, status }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const statusFromQuery = searchParams.get("status") || status;

  const {
    archiveList = [],
    loading = false,
    totalPages = 0,
  } = useSelector((state) => state.bankingSlice || {});
  const [expanded, setExpanded] = useState(-1);
  const [page, setPage] = useState(0);
  const [size] = useState(10);

  useEffect(() => {
    setPage(0);
    setExpanded(-1);
  }, [statusFromQuery]);

  useEffect(() => {
    setExpanded(-1);
  }, [type, status]);

  useEffect(() => {
    setExpanded(-1);
  }, [page]);

  const handleAccordionChange = useCallback(
    (val) => {
      setExpanded((prev) => (prev === val ? -1 : Number(val)));
    },
    [setExpanded]
  );

  const handlePageChange = useCallback((newPage) => {
    setPage(newPage);
    setExpanded(-1);
  }, []);

  useEffect(() => {
    if (statusFromQuery) {
      const apiStatus =
        statusFromQuery === "Closed" ? "PAST" : statusFromQuery.toUpperCase();
      dispatch(
        fetchBankingArchive({ status: apiStatus, currentPage: page, size })
      );
    }
  }, [dispatch, statusFromQuery, page, size]);

  return (
    <>
      <div
        style={{
          height: "calc(100vh - 230px)",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <LoaderNoData loading={loading} dataLength={archiveList?.length ?? 0} />

        {statusFromQuery === "Closed" ? (
          <>
            {archiveList?.length > 0 && <SummaryHeader />}
            {archiveList?.map((ele, index) => (
              <SummaryRow
                key={ele?.id ?? ele?.name ?? index}
                ele={ele}
                index={index}
                expanded={expanded}
                onToggle={handleAccordionChange}
              />
            ))}
          </>
        ) : statusFromQuery === "Withdrawn" ? (
          <>
            {archiveList?.length > 0 && <SummaryHeaderWithdrawn />}
            {archiveList?.map((ele, index) => (
              <SummaryRowWithdrawn
                key={ele?.id ?? ele?.name ?? index}
                ele={ele}
                index={index}
                expanded={expanded}
                onToggle={handleAccordionChange}
              />
            ))}
          </>
        ) : statusFromQuery === "Expired" ? (
          <>
            {statusFromQuery === "Expired" && archiveList?.length > 0 && (
              <SummaryHeaderExpired />
            )}
            {/* {archiveList?.map((ele, index) => {
              if (statusFromQuery === "Expired") {
                return (
                  <SummaryRowExpired
                    key={ele?.id ?? index}
                    ele={ele}
                    index={index}
                    expanded={expanded}
                    onToggle={handleAccordionChange}
                  />
                );
              } else if (statusFromQuery === "Completed") {
                return (
                  <SummaryRow
                    key={ele?.id ?? index}
                    ele={ele}
                    index={index}
                    expanded={expanded}
                    onToggle={handleAccordionChange}
                  />
                );
              } else {
                return null;
              }
            })} */}
            {archiveList?.map((ele, index) => (
              <SummaryRowExpired
                key={ele?.id ?? ele?.name ?? index}
                ele={ele}
                index={index}
                expanded={expanded}
                onToggle={handleAccordionChange}
              />
            ))}
          </>
        ) : null}
      </div>
      {archiveList?.length > 0 && (
        <div className={Styles.paginationWrapper}>
          <button
            disabled={page <= 0}
            onClick={() => handlePageChange(page - 1)}
          >
            Previous
          </button>
          <span>
            Page {page + 1} of {totalPages || 1}
          </span>
          <button
            disabled={page + 1 >= totalPages}
            onClick={() => handlePageChange(page + 1)}
          >
            Next
          </button>
        </div>
      )}
    </>
  );
};

export default BankingArchive;
